import { cn } from '@/lib/utils';
import type { Capability } from '@/types/fleet';

const CAPABILITY_STYLES: Record<Capability, string> = {
  standard: 'border-border bg-secondary text-muted-foreground',
  stealth: 'border-status-active/30 bg-status-active/10 text-status-active',
  tor: 'border-status-inflight/30 bg-status-inflight/10 text-status-inflight',
  mixnet: 'border-status-inflight/30 bg-status-inflight/10 text-status-inflight',
  p2p: 'border-status-degraded/30 bg-status-degraded/10 text-status-degraded',
};

export function CapabilityChip({
  capability,
  className,
}: {
  capability: Capability;
  className?: string;
}): JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded border px-1.5 py-0.5 font-mono text-[10px] font-medium uppercase tracking-wide',
        CAPABILITY_STYLES[capability] ?? 'border-border bg-secondary text-muted-foreground',
        className,
      )}
    >
      {capability}
    </span>
  );
}
